/**
 * Parses top-level `source` from `Goal.diagnosis_content` JSON.
 */
export function parseDiagnosisContentSource(
  raw: string | undefined,
): string | undefined {
  if (!raw?.trim()) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return undefined;
    }

    const source = (parsed as Record<string, unknown>).source;
    if (typeof source !== "string" || !source.trim()) {
      return undefined;
    }

    return source.trim();
  } catch {
    return undefined;
  }
}
